// Create a new file for centralized error message handling
export const ERROR_CODES = {
  TRY_AFTER_SOME_TIME: 'TRY_AFTER_SOME_TIME',
  USER_ACCOUNT_BLOCKED: 'USER_ACCOUNT_BLOCKED',
  OTP_REQUIRED: 'OTP_REQUIRED',
  MAX_OTP_LIMIT_EXCEEDED: 'MAX_OTP_LIMIT_EXCEEDED',
  MAX_RESEND_REACHED: 'MAX_RESEND_REACHED',
  INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
};
